<template>
  <div class="btn__back-to-top" @click="onBackToTopClick" :style="{ marginBottom: browser.isIE || browser.isEdge ? '40px' : '0px' }">
    <i class="icon icon--back-to-top"></i>
    <p>{{ $t('common.backToTop') }}</p>
  </div>
</template>

<script>
import browser from '../../libs/browser'

export default {
  name: 'BackToTop',
  props: [
    'refName'
  ],
  methods: {
    onBackToTopClick () {
      if (!this.refName) {
        console.error('no refName for scrllTo')
      }

      let component = this
      let target

      while (component) {
        target = component.$refs[this.refName]

        if (target) {
          if (target.$el) {
            target = target.$el
          }
          break
        }
        component = component.$parent
      }

      if (target) {
        target.scrollTop = 0
      } else {
        console.error('no target for scrllTo')
      }
      this.$emit('onBackToTopClick')
    }
  },
  data () {
    return {
      browser: browser
    }
  }
}
</script>

<style lang="scss" scoped>
.btn__back-to-top {
  cursor: pointer;
  width: 100px;
  margin: 40px auto 0;
  text-align: center;

  .icon {
    position: relative;

    &:hover {
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.06);
        border-radius: 50%;
      }
    }
  }

  p {
    margin-top: 8px;
    font-weight: 500;
  }
}
</style>
